import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { StorageService } from './storage.service';
import { HttpService } from './http.service';
import { Resolve, Router } from '@angular/router';
import { UserService } from './user.service';
import { EnvironmentService } from './environment.service';

@Injectable()
export class AuthorizationService  {

  private permission$: Observable<boolean>;
  constructor(
    private storageService: StorageService,
    private httpService: HttpService,
    private envService: EnvironmentService,
    private userService: UserService,
    private router: Router

  ) {
  }

  public getStorePermissions(): Observable<any> {
    const uuid = this.storageService.getLocalItem('uuid');
    const url = 'stores/' + this.envService.getStore('storeId') + '/users/' + uuid +  '/permissions';

    return this.httpService.get(url).map(
      (response: Array<any>) => {
        let permissions = null;
        if (!response || response.length === 0) {
          this.router.navigate(['/restrict/unauthorized']);
        } else {
          permissions = {};
          response.forEach(entity => {
            permissions[entity.entityType] = entity;
          });
        }
        return permissions;
      }
    ).catch(
      (error: any) => {
        this.router.navigate(['/restrict/nostore']);
        return error;
      }
    );
  }

  public hasApiReadAccess(): Observable<boolean> {
    this.permission$ = this.getStorePermissions();
    return this.permission$.map(
      (permissions: any) => {
        return (permissions && permissions.apis && permissions.apis.read);
      },
      (error) => {
        console.log(error);
        return false;
      }
    );
  }

  public hasApiWriteAccess(): Observable<boolean> {
    this.permission$ = this.getStorePermissions();
    return this.permission$.map(
      (permissions: any) => {
        return (permissions && permissions.apis && permissions.apis.write);
      },
      (error) => {
        console.log(error);
        return false;
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/services/authorization.service.ts